<template>
  <footer v-show="isScreenCapture" class="resultv2_function_bar function-bar">
    <div class="function-inner">
      <template v-if="isTrades">
        <template v-if="isApp">
          <div
            v-if="isSupportRecordScreen && recordingState"
            class="function-hd"
          >
            <NameCard :name-card-infor="data" />
          </div>
          <BtnLayer
            :is-policy-check="isPolicyCheck"
            :is-scheme-show="isSchemeShow"
            :is-trade="true"
            @invoke="handleInvoke"
          />
        </template>
        <template v-else>
          <a
            key="ljtb"
            class="btn insured"
            :href="dataTrade0.productInfo && dataTrade0.productInfo.shareTradeUrl"
            data-stat-id="lktb"
            :data-stat-ep="
              JSON.stringify({
                cpId: dataTrade0.productInfo.tradeId,
              })
            "
          >立即投保</a>
        </template>
      </template>
      <BtnLayer
        v-else-if="isShowButtons"
        :is-jump-to-compare3="isJumpToCompare3"
        :is-gaoke-agent="isGaokeAgent"
        :is-policy-check="isPolicyCheck"
        :is-scheme-show="isSchemeShow"
        :is-show-theme-picker="isShowThemePicker"
        @invoke="handleInvoke"
      />
    </div>
    <ExportImagesPopup
      v-model="popConfig.visible"
      :scene="3"
      :plain-result-data="plainResultData"
      :liability-show-type="liabilityShowType"
      :interest-data="interestData"
      :theme-settings="themeSettings"
      :export-risk-has-interest-demo="exportRiskHasInterestDemo"
      :export-risk-has-bonus="exportRiskHasBonus"
      @openThemePicker="$emit('openThemePicker')"
      @openInterestSettingPopup="$emit('openInterestSettingPopup')"
      @screen-capture="screenCapture"
    />
  </footer>
</template>
<script>
import { mapState } from 'vuex'
import QS from 'qs'
import { isWeCom } from 'base/config'
import { isApp, APP_CHANNEL, URL_PARAM, getUrlParams } from 'common/utils/variables'
import { PLANBOOK_PAGE_MAP } from '@/config/assets'
import { showTopArrow } from '../../js/handler'
import { get as _get ,cloneDeep} from 'lodash'
import NameCard from '@/components/footer/nameCard.vue'
import BtnLayer from '@/components/footer/childComponents/btnLayer.vue'
import ExportImagesPopup from '../exportImages/popup.vue'
import {saveComparev3} from '@/pages/planbkTemplatev2/js/api'
import {DEFAULT_INTEREST_KEY_MAP,DEFAULT_MODULENAME,createdTableSettingMap} from './constant'
import {calcCompareInsurance, getCompareCaseByInsuranceId,saveComparePlan,getCompareInterestDetailWithTiers} from '@/pages/planbkTemplatev2/js/handler'
const { weapp, shareFrom, sharePlatform, familyhead, jumpSource, pbType } = URL_PARAM

export default {
  components: {
    NameCard,
    BtnLayer,
    ExportImagesPopup
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    liabilityShowType: {
      type: Number,
      default: 0
    },
    plainResultData: {
      type: Object,
      default: () => ({})
    },
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    isSupportRecordScreen: {
      type: Boolean,
      default: false
    },
    interactionOn: Boolean,
    isScreenCapture: {
      type: Boolean,
      default: false
    },
    isForPresentation: {
      type: Boolean,
      default: false
    },
    isTrades: {
      type: Boolean,
      default: false
    },
    recordingState: {
      type: Boolean,
      default: false
    },
    isPolicyCheck: {
      type: Boolean,
      default: false
    },
    jumpSource: {
      type: Number,
    },
    exportRiskHasInterestDemo: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    },
    exportRiskHasBonus: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    }
  },
  data () {
    return {
      popConfig: {
        visible: false
      },
      isApp,
      isGaokeAgent: APP_CHANNEL === 'WECHAT_GAOKE',
      compareCase:{},
      compareUuid:null,
      isJumpToCompare3:0,
      primaryUuid:null,
      settingData: (() => {
        const detailRecordList = [
          { key: 'case', isHide: 0, isTop: 0 },
          { key: 'baof', isHide: 0, isTop: 0 },
          { key: 'company', isHide: 0, isTop: 0 },
          { key: 'bonus', isHide: 0, isTop: 0 },
        ]
        const interestTableList = createdTableSettingMap(DEFAULT_INTEREST_KEY_MAP)
        const interestKeyMap = cloneDeep(DEFAULT_INTEREST_KEY_MAP)
        const interestKeyOrder = cloneDeep(interestTableList)
          .filter(e => e.type)
          .map(e => {
            delete e.isHide
            delete e.display
            return e
          })
        // captureHideKeyData将在用户选择后动态更新
        const moduleNamesHorizontal=['case','baof','baoe','businessCard']
        const moduleNamesVertical=cloneDeep(DEFAULT_MODULENAME)
        const showMap = {
          tableShow: 'year',
          yearShow: 'end',
          nameHide: []
        }
        return {
          // 1-纵向 2-横向
          tableDirection: 1,
          collect:false,
          detailRecordList,
          interestTableList,
          interestKeyMap,
          interestKeyOrder,
          moduleNamesHorizontal,
          moduleNamesVertical,
          showMap
        }
      })(),
    }

  },
  computed: {
    ...mapState({
      interestData: 'interestData'
    }),
    isPlatformUser () {
      return isApp || isWeCom || ['WECHAT_GAOKE', 'WXMP', 'WXMP_BXZ', 'BaoXiaoZhu', 'H5_BXZ'].includes(APP_CHANNEL)
    },
    isShowButtons () {
      return this.isPlatformUser || this.isGaokeAgent
    },
    // 是否显示讲解方案按钮
    isSchemeShow () {
      const { recordingState, isSupportRecordScreen, interactionOn } = this
      const isSupportScreenExplanation = interactionOn && !['WXMP', 'WXMP_BXZ', 'NUOYA', 'BaoXiaoZhu', 'H5_BXZ'].includes(APP_CHANNEL)
      const isSupportAnimationExplanation = ['BXS'].includes(APP_CHANNEL)
      return !recordingState && !['WECHAT_GAOKE', 'WXMP', 'WXMP_BXZ'].includes(APP_CHANNEL) && (isSupportScreenExplanation || isSupportRecordScreen || isSupportAnimationExplanation)
    },
    isShowThemePicker () {
      const { isGaokeAgent, isPolicyCheck, isPlatformUser } = this
      if (isGaokeAgent || isPolicyCheck) {
        return false
      }
      if (['NUOYA'].includes(APP_CHANNEL)) {
        return false
      }
      return isPlatformUser
    }
  },
  watch:{
    jumpSource:{
      immediate:true,
      deep:true,
      handler(val){
        this.isJumpToCompare3 = val
      }
    }
  },
  created () {
    this.primaryUuid=sessionStorage.getItem('compareUuid')||null
  },
  methods: {
    jumpTo (url) {
      if (!url) return
      location.href = url
    },
    async handleInvoke (type) {
      const { data, isGaokeAgent, isPolicyCheck } = this
      // 交易-立即投保
      if (type === 'insured') {
        const trade0ProductInfo = data && data.trades && data.trades[0] && data.trades[0].productInfo
        if (trade0ProductInfo) {
          window.WeiyiStatSDK.submit('lktb', {
            cpId: trade0ProductInfo.tradeId
          })
          this.jumpTo(trade0ProductInfo.tradeUrl)
        }
        return
      }

      // 保单年检保存
      if (type === 'save') {
        if (isPolicyCheck) {
          const params = {
            nw: 1,
            cid: familyhead
          }
          if (isGaokeAgent) {
            params.nw = undefined
            params.jumpSource = jumpSource
          }
          this.jumpTo(`${PLANBOOK_PAGE_MAP.policyInspectionFamilyPolicy}?${QS.stringify(params)}`)
        }
        return
      }
      if(type==='compare3'){
        if(this.primaryUuid) {
          const url = `${PLANBOOK_PAGE_MAP.planbookInputCompare3}?uuid=${this.primaryUuid}`
          if(['H5_BXZ'].includes(APP_CHANNEL)) {
            window.open(url)
          } else {
            location.href = url
          }
          return;
        }
        //console.log(this.plainResultData);
        const insuranceSource=_get(this.plainResultData.resultData,'productGroupList[0]')
        const insuranceList = [_get(insuranceSource.prodOrderList[0], 'mulInsOrderList[0]', {})];
        const personList = [_get(this.plainResultData.resultData.personData, 'personOrderList[0]', [])];
        const insuranceId=_get(insuranceList[0], 'key')
        const _insuranceResponse = await calcCompareInsurance({
          resultSource: null,
          personList,
          insuranceList
        }).catch(() => {})
        let compareCase = await getCompareCaseByInsuranceId(insuranceId).catch(() => { })
        const source = compareCase?.insureData?.interestSetting || {};
        this.interestSetting = {
          ...this.interestSetting,
          accRate:_get(source,'accRate'),
          addAndTakeData:_get(source,'addAndTakeData'),
          bonus: _get(source.bonus,'value'),
          bonusRealRate: _get(source,'bonusRealRate'),
          bonusSyncFlag: _get(source,'bonusSyncFlag'),
          bonusTake: _get(source.bonusTake,'value'),
          pensionTake: _get(source.pensionTake,'value'),
          reduceBaofData: _get(source,'reduceBaofData'),
        };
        if (_insuranceResponse && _insuranceResponse.length) {
          const _resultResponse = await saveComparePlan({
            resultSource: null,
            planUuid: null,
            personList,
            insuranceList: _insuranceResponse,
            interestSetting: this.interestSetting,
          }).catch(() => {})
          if (_resultResponse) {
              this.compareCase.resultData = _resultResponse.data.data
              this.compareCase.insureData = _get(this.plainResultData,'resultData')
              const detailData=_resultResponse.data.data && (await getCompareInterestDetailWithTiers([_resultResponse.data.data]).catch(() => {})) || []
              this.compareCase.interestDetailData = detailData.data.data
              const requestParams={
                compareUuid:this.compareUuid,
                planList: this.compareCase.resultData ? [{ planUuid: _get(this.compareCase, 'resultData.planUuid') }].filter(e => !!e.planUuid) : [],
                compareData:JSON.stringify(this.settingData)
              }
              return saveComparev3(requestParams).then(data=>{
                const uuid=_get(data.data, 'data')
                if(uuid) {
                  sessionStorage.setItem('compareUuid', uuid);
                  this.primaryUuid = uuid;
                  const url = `${PLANBOOK_PAGE_MAP.planbookInputCompare3}?uuid=${uuid}`
                  if(['H5_BXZ'].includes(APP_CHANNEL)) {
                    window.open(url)
                  } else {
                    location.href = url
                  }
                }
                return Promise.resolve(uuid)
              })
          }
        }
        window.WeiyiStatSDK.submit('bottom_bar_interest_comparison')
      }

      if (type === 'share') {
        if (isGaokeAgent || ['WECHAT_GAOKE', 'WXMP_BXZ'].includes(APP_CHANNEL)) {
          showTopArrow()
          return
        }
        if (['WXMP', 'WXMP_BXZ'].includes(APP_CHANNEL)) {
          const { uuid, theme } = getUrlParams()
          const toUrl = `${location.origin + location.pathname}?${QS.stringify({
            uuid,
            theme,
            cardUuid: _get(data, 'uuid'),
            inGroup: true,
            shareFrom: 'mpH5ShareBtn'
          })}`
          wx.miniProgram.navigateTo({
            url: `/pages/subscribe/index?toUrl=${encodeURIComponent(toUrl)}`
          })
          console.log('toUrl', toUrl)
          return
        }
      }

      // 新版导出图片，依赖版本@7.23.0
      if (type === 'generate-image') {
        this.popConfig = {
          visible: true
        }
        window.WeiyiStatSDK.submit('JGY_TPYL_V2', {
          scene: 3
        })
        return
      }

      // 同屏讲解
      if (type === 'interpretation') {
        window.WeiyiStatSDK.submit('jiangjie')
      }

      this.$emit(type)
    },
    screenCapture(done) {
      this.$emit('screen-capture', done)
    }
  }
}
</script>

<style>
  @import './index.css';
</style>
